var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:_vm.classObject,attrs:{"type":"button","aria-label":_vm.label,"aria-controls":_vm.target.id ? _vm.target.id : _vm.target,"aria-expanded":_vm.toggleState ? 'true' : 'false'},on:{"click":_vm.onclick}},[_vm._t("default",[_c('span',{staticClass:"navbar-toggler-icon"})])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3a69a29c","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/bootstrap-vue/es/components/navbar/navbar-toggle.vue
// module id = 1088
// module chunks = 75